import { ActionStore } from "higher-order/ActionStore";
import { observable } from "mobx";
import ModalModel from "gradifui/models/ModalModel";

export const MS_AT_WORK_VIDEO_KEY = 0;
export const ANDERSEN_TAX_VIDEO_KEY = 1;

class HomeStore extends ActionStore {

    @observable videoModals = [];

    constructor(props, dispatcher) {
        super(dispatcher);

        this.enabledOffers = props.enabledOffers;
        for (let i = 0; i < 2; i++) {
            const videoModal = new ModalModel("marketingVideo" + i);
            videoModal.allowScrollBar = false;
            videoModal.hideHeader = true;
            videoModal.shouldCloseOnOverlayClick = true;
            this.videoModals.push(videoModal);
        }
        this.registerModals(this.videoModals);
    }
}

export default HomeStore;
